import { Toast } from 'modules/ui';
import { ToastProps } from 'modules/ui/toast/Toast';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import { StyledToastContainer, StyledTransitionGroup } from './styled';
import { useToastContainer } from './useToastContainer';

export const ToastContainer: React.FC = () => {
  const { activeToasts, addToast } = useToastContainer();
  const { t } = useTranslation();

  const systemErrorMessage = useMemo(
    () => localStorage.getItem('systemError'),
    [],
  );

  useEffect(() => {
    systemErrorMessage &&
      addToast({
        title: t('toastMessages.systemErrorTitle'),
        text: t(`toastMessages.${systemErrorMessage}`),
      });
    localStorage.removeItem('systemError');
  }, [addToast, t, systemErrorMessage]);

  return (
    <StyledToastContainer className="full-width-container">
      <StyledTransitionGroup>
        {activeToasts.map((toastProps: ToastProps) => (
          <CSSTransition key={toastProps.id} timeout={500} classNames="toast">
            <Toast {...toastProps} />
          </CSSTransition>
        ))}
      </StyledTransitionGroup>
    </StyledToastContainer>
  );
};
